module.exports = __webpack_public_path__ + "static/media/android-whatsapp-config.a5c00588.svg";